import type { Node } from "interfaces/schemas";
import * as treeUtils from "utils/treeUtils";

export const applyPartiallyVisbileNodes = (tree: Node[] | null): void => {
  if (tree === null) {
    return;
  }

  const [rootNode] = tree;

  calculateNodePartiallyVisibleStatus(rootNode);
};

const calculateNodePartiallyVisibleStatus = (node: Node) => {
  const { nodes, active } = node;
  // Early return if the node is not active.
  if (!active) {
    node.partiallyVisible = false;
    return { isActive: false, isPartiallyVisible: false };
  }
  // early return if the node has no children.
  if (!nodes || nodes.length === 0 || treeUtils.isAnyProduct(node)) {
    node.partiallyVisible = false;
    return { isActive: node.active, isPartiallyVisible: false };
  }

  let activeCount = 0;

  for (const child of nodes) {
    const { isActive, isPartiallyVisible } =
      calculateNodePartiallyVisibleStatus(child);
    if (isActive) {
      activeCount += 1;
    }
    if (isPartiallyVisible) {
      node.partiallyVisible = true;
      return { isActive: true, isPartiallyVisible: true };
    }
  }

  const partiallyVisible = activeCount > 0 && activeCount !== nodes.length;

  node.partiallyVisible = partiallyVisible;

  if (activeCount === 0) {
    node.active = false;
    node.partiallyVisible = false;
    return { isActive: false, isPartiallyVisible: false };
  }

  return { isActive: true, isPartiallyVisible: partiallyVisible };
};
